import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useGetUser } from "./useGetUser";
import SpinnerFullPage from "../../ui/SpinnerFullPage";

function RequireUsername({ children }: { children: React.ReactNode }) {
  const { user, isPending } = useGetUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (isPending) return;
    if (!user?.username) {
      navigate("/login/username", { replace: true });
    }
  }, [isPending, user, navigate]);

  if (isPending) return <SpinnerFullPage />;
  if (!user?.username) return null;

  return <>{children}</>;
}

export default RequireUsername;
